import { Component, OnInit, OnDestroy } from '@angular/core';
import { froalaConfig } from '@app/shared/config/froala.config';
import { OrgBuilderFacade } from '@app/org-builder/state/org-builder.facade';
import { BusinessUnit } from '@entities/business-unit';
import { UserOrgFacade } from '@app/user-org/state/user-org.facade';
import { TeamFacade } from '@app/team/state/team.facade';
import { TeamMember } from '@entities/team-member';
import { Department } from '@entities/department';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
   selector: 'app-org-summary-report',
   templateUrl: './org-summary-report.component.html',
   styleUrls: ['./org-summary-report.component.scss'],
})
export class OrgSummaryReportComponent implements OnInit, OnDestroy {
   options = {
      ...froalaConfig,
      documentReady: true,
      toolbarButtons: ['print'],
   };

   orgName: string;
   logo: string;
   businessUnits: BusinessUnit[] = [];
   departments: Department[] = [];
   teamMembers: TeamMember[] = [];

   loaded = {
      org: false,
      businessUnits: false,
      departments: false,
      teamMembers: false,
   };

   private destroyed$ = new Subject<void>();

   constructor(
      private orgBuilderFacade: OrgBuilderFacade,
      private userOrgFacade: UserOrgFacade,
      private teamFacade: TeamFacade
   ) {}

   ngOnInit() {
      this.orgBuilderFacade.businessUnits$
         .pipe(takeUntil(this.destroyed$))
         .subscribe((businessUnits) => {
            this.businessUnits = businessUnits.sort((a, b) => a.order - b.order);
            this.loaded.businessUnits = businessUnits.length > 0;
         });
      this.userOrgFacade.selectedOrg$.pipe(takeUntil(this.destroyed$)).subscribe((org) => {
         if (org) {
            this.orgName = org.name;
            this.logo = org.logo;
            this.loaded.org = true;
         }
      });
      this.teamFacade.teamMembers$.pipe(takeUntil(this.destroyed$)).subscribe((teamMembers) => {
         this.teamMembers = teamMembers;
         this.loaded.teamMembers = teamMembers.length > 0;
      });
      this.orgBuilderFacade.departments$.pipe(takeUntil(this.destroyed$)).subscribe((depts) => {
         this.departments = depts;
         this.loaded.departments = depts.length > 0;
      });
   }

   ngOnDestroy() {
      this.destroyed$.next();
      this.destroyed$.complete();
   }

   allLoaded() {
      return Object.values(this.loaded).reduce((a, b) => a && b);
   }

   getTeamMemberName(id: string) {
      const teamMember = this.teamMembers.find((t) => t.id == id);
      if (teamMember) {
         return `${teamMember.firstName} ${teamMember.lastName}`;
      } else {
         return '';
      }
   }

   getDepartments(businessUnitId: string) {
      const depts = this.departments.filter((d) => d.businessUnitId == businessUnitId);
      return depts.sort((a, b) => a.order - b.order);
   }

   back() {
      history.back();
   }
}
